<dashboardnav>
  
    <cradua-security-classification
    [securityclassifications]="securityclassifications$ | async"
    (securityclassification)="onSubmitSecurityClassification($event)"
    (deleteSecurityClassificationEvent)="onDeleteSecurityClassification($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-security-classification>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  